module.exports = __webpack_public_path__ + "media/images/front/icon_06_arrow_y-382076106c1df5c47adc74752dbd5164.png";